import { render, staticRenderFns } from "./NovelListDialog.vue?vue&type=template&id=31f9837a&scoped=true&"
import script from "./NovelListDialog.vue?vue&type=script&lang=ts&"
export * from "./NovelListDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NovelListDialog.vue?vue&type=style&index=0&id=31f9837a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9837a",
  null
  
)

export default component.exports